import { Box, Grid } from "@mui/material";
import React from "react";
import { Mytable, Rows } from "../../../../components/mui/DataGrid/Details";

export const Details = ({ data }) => {
    return (
        <div>
            <Box>
                <Grid container spacing={1}>
                    <Mytable
                        tableRow={
                            <>
                                <Rows label="Class" value={data?.class} />
                                <Rows label="Mobile" value={data?.mobile} />

                                <Rows label="Course" value={data?.course} />
                            </>
                        }
                    />

                    <Mytable
                        tableRow={
                            <>
                                <Rows label="Status" value={data?.status} />
                                <Rows label="Remark" value={data?.remark} />
                            </>
                        }
                    />
                </Grid>
            </Box>
        </div>
    );
};
